const ACTION_RANK = { view: 1, edit: 2 };

export function grantCovers(grants, app, module, action = "view") {
  const need = ACTION_RANK[action] || 0;
  if (!need || !Array.isArray(grants)) return false;
  return grants.some((grant) => {
    if (!grant || grant.app !== app || grant.module !== module) return false;
    return (ACTION_RANK[grant.action] || 0) >= need;
  });
}

/** Normalize JWT / legacy crew|chef → employee. */
export function normalizeSessionRole(role) {
  const r = String(role || "").trim().toLowerCase();
  if (r === "crew" || r === "chef") return "employee";
  if (r === "manager") return "store_manager";
  return r;
}

export function isEmployeeRole(userOrRole) {
  if (userOrRole == null) return false;
  const r =
    typeof userOrRole === "object"
      ? normalizeSessionRole(userOrRole.role)
      : normalizeSessionRole(userOrRole);
  return r === "employee";
}

export function canAccessOpsModule(user, module, action = "view") {
  if (!user) return false;
  if (grantCovers(user.grants, "ops", module, action)) return true;
  // Legacy sessions without grants attached.
  const role = normalizeSessionRole(user.role);
  if (module === "recipes" && (role === "employee" || role === "admin") && action === "view") {
    return String(user.role || "").toLowerCase() === "chef" || role === "admin";
  }
  return false;
}

/** Same bar as OS Identity: OS identity edit, or legacy Ops admin role. */
export function canManageIdentities(user) {
  if (!user) return false;
  if (grantCovers(user.grants, "os", "identity", "edit")) return true;
  return normalizeSessionRole(user.role) === "admin";
}

export function canImpersonateUsers(user) {
  if (!user || user.impersonated) return false;
  return Boolean(user.can_impersonate);
}

/** SoftOne / Ergani upload — HR or Super Admin (not while impersonating). */
export function canPushFoxline(user) {
  if (!user) return false;
  if (user.impersonated) return false;
  if (canImpersonateUsers(user) || user.is_super_admin) return true;
  return normalizeSessionRole(user.role) === "hr";
}

/** HR Dashboard page. HR role always has it; an Ops hr_dashboard grant does too. */
export function canAccessHrTools(user) {
  if (!user) return false;
  if (normalizeSessionRole(user.role) === "hr") return true;
  return grantCovers(user.grants, "ops", "hr_dashboard", "view");
}

/** Cross-store Ops scope (all / brand) from grants, with role fallback. */
export function hasBroadOpsScope(user) {
  if (!user) return false;
  const grants = user.grants || [];
  if (grants.some((g) => g.app === "ops" && (g.scope_type === "all" || g.scope_type === "brand"))) {
    return true;
  }
  const role = normalizeSessionRole(user.role);
  return ["admin", "brand_manager", "ops_manager", "hr"].includes(role);
}
